"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var countryBuilder = function countryBuilder(_a) {
  var country = _a.country;

  if (!country) {
    return '';
  }

  return "country:\"" + country + "\"";
};

var _default = countryBuilder;
exports["default"] = _default;